<app-users-table [users]="users$ | async"
  (deleteUser)="deleteUser($event)"></app-users-table>
